export default function About() {

  return (
    <section id="about" className="bg-[#111318] py-28 md:py-36">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <span className="text-slate-400 text-xs font-semibold tracking-[0.25em] uppercase">About VETON OOD</span>
        </div>

        <div className="bg-[#1c1f27] rounded-3xl p-10 md:p-16 mb-16">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
                A Team of Experts Shaping the iOS Ecosystem
              </h2>
              <p className="text-slate-400 text-lg leading-relaxed mb-6">
                VETON OOD is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
              </p>
              <p className="text-slate-500 text-base leading-relaxed">
                We believe that great software should be invisible — it should work seamlessly in the background, protecting and optimizing your device without getting in the way of your daily life.
              </p>
            </div>
            <div className="relative">
              <div className="rounded-2xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://public.readdy.ai/ai/img_res/14cd165cd1e2cb9b52274726656dfeaf.jpg"
                  alt="VETON OOD development team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-slate-800 rounded-2xl p-5 border border-slate-700">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/20 rounded-xl">
                    <i className="ri-shield-check-line text-emerald-400 text-xl" />
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">Security First</p>
                    <p className="text-slate-400 text-xs">Every product we build</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
}
